export const uk = {
    'moderation-pending': 'Ожидает модерации операторов',
    'moderation-rejected': 'Отклонено у некоторых операторов'
};
